import React, { forwardRef, useState } from "react";
import { Block, Layer, useThemeName } from "thorium-ui";
import ContactComponents from "../components/contact";

export const Contact = forwardRef((props, ref) => {
   const [messageSent, setMessageSent] = useState(false);
   const themeName = useThemeName();
   return (
      <div
         ref={ref}
         id="contact-view"
         className={`suspense-wrapper contact-view  ${themeName}`}
      >
         <Layer
            justify="center"
            className={`section ${props.visible ? "visible" : ""}`}
         >
            <Block xs={12} sm={10} md={8} lg={8} xl={6} className="px-0">
               {!messageSent && (
                  <ContactComponents.ContactForm
                     onSubmit={() => setMessageSent(true)}
                  />
               )}
               {messageSent && <ContactComponents.SuccessMessage />}
            </Block>
            <Block xs={12} sm={10} md={8} lg={6} xl={7} className="px-0">
               <ContactComponents.SocialLinks />
            </Block>
         </Layer>
      </div>
   );
});

export default Contact;
